"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _brands = require("@/api/brands");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _index = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _common = require("@/api/common");
var _vueAdvancedCropper = require("vue-advanced-cropper");
require("vue-advanced-cropper/dist/style.css");
var _admin = require("@/store/modules/admin");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.image = [];
    this.isSuperAdmin = false;
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, _brands.defaultBrandData);
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'Please enter name',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }]
    };
    this.cropperVisible = false;
    this.imageSrc = '';
    this.selectedFile = null;
  }
  // 1️⃣ When user selects file
  onFileSelected(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.selectedFile = file;
    const reader = new FileReader();
    reader.onload = e => {
      this.imageSrc = e.target.result;
      this.cropperVisible = true;
    };
    reader.readAsDataURL(file);
  }
  // 2️⃣ Crop image
  cropImage() {
    const cropper = this.$refs.cropper;
    const canvas = cropper.getResult().canvas;
    canvas.toBlob(async blob => {
      var _this$selectedFile;
      const formData = new FormData();
      formData.append('file', blob, (_this$selectedFile = this.selectedFile) === null || _this$selectedFile === void 0 ? void 0 : _this$selectedFile.name);
      const response = await (0, _common.uploadFile)(formData);
      this.formData.image = response;
      this.cropperVisible = false;
    }, 'image/png');
  }
  triggerFileInput() {
    this.$refs.fileInput.click();
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    this.isSuperAdmin = _admin.AdminModule.roles.toString() === 'Super Admin';
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.redirectToList = true;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, _brands.defaultBrandData);
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _brands.getBrandById)(id);
      Object.keys(this.formData).forEach(key => {
        this.$set(this.formData, key, data[key]);
      });
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  imageUploaded(file) {
    this.formData.image = file.file.response;
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  fileUploaded(file) {
    this.formData.image = file.response;
  }
  async saveForm() {
    try {
      this.loading = true;
      let savedBrand = null;
      console.log('Saving brand with data:', this.formData); // Debug log
      if (this.isEdit) {
        savedBrand = await (0, _brands.updateBrand)(this.formData.id, this.formData);
      } else {
        savedBrand = await (0, _brands.createBrand)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Brand saved successfully',
        type: 'success',
        duration: 2000
      });
      this.$emit('saved', {
        showDialog: false,
        savedBrand: savedBrand
      });
      if (this.redirectToList) {
        _router.default.push('/brand/list');
      }
    } catch (err) {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: true
})], default_1.prototype, "redirectToList", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'BrandDetail',
  components: {
    FileUpload: _index.default,
    Cropper: _vueAdvancedCropper.Cropper
  }
})], default_1);
var _default = exports.default = default_1;